// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import TopHeader from '../../components/common/topHeader';
import LotteryInfo from '../../components/pages/myCollection/lotteryDetail/LotteryInfo';
import LotteryCard from '../../components/pages/myCollection/lotteryDetail/LotteryCard';
import LotteryIcon from '../../components/pages/myCollection/lotteryDetail/LotteryIcon';
import TButton from '../../components/common/button';
import HistoryPurchase from '../../components/pages/myCollection/lotteryDetail/HistoryPurchase';
import { dotted, facebookIcon, GUIDE, iconBeside, twitterIcon } from '../../../assets/imgs';
import ModalDiscardGuide from '../../components/common/modalDiscardGuide';

const MyCollectionLotteryDetailPC = (props) => {
  const { lotteryData, handleShare, getWidth } = props;
  const hasCancelFlag = lotteryData.lottery_info?.has_cancel_flag;

  const { lotteryId } = useParams();

  const [isShowDiscardGuide, setShowDiscardGuide] = useState(false);

  const eleWrap = document?.getElementById('share-sns-wrapper')?.offsetWidth;

  const [width, setWidth] = useState(eleWrap);
  useEffect(() => {
    setWidth(eleWrap);
  }, [eleWrap]);
  useEffect(() => {
    if (width) {
      getWidth(width);
    }
  }, [width]);
  useEffect(() => {
    function handleResize() {
      setWidth(document.getElementById('share-sns-wrapper')?.offsetWidth);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const history = useHistory();

  return (
    <>
      <TopHeader title="MYコレクション" />
      <div className="main-content" style={{ marginTop: -31 }}>
        <LotteryInfo lotteryInfo={lotteryData.lottery_info} />
        <div className="fw-bold mb-3 AOTFShinMaruGoPro" style={{ marginTop: 80, fontSize: 20 }}>
          当せん賞品
        </div>
        <div className="text-follow NotoSansJP">当せんした商品は以下になります。</div>
        {!hasCancelFlag ? (
          <div className="NotoSansJP my-color-red">※このくじは破棄対象外です</div>
        ) : (
          lotteryData.lottery_info?.can_discard && (
            <div className="NotoSansJP">
              受取数を調整したい方は
              <span
                style={{ color: '#2ADAD1', cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => setShowDiscardGuide(true)}
              >
                破棄について
              </span>
              を確認ください。
              <span style={{ color: '#FF0000' }}>
                破棄数変更期限：{lotteryData.lottery_info?.discard_due_date} まで
              </span>
            </div>
          )
        )}
        <div className="d-flex flex-wrap" style={{ marginTop: 60 }}>
          {lotteryData?.list_detail?.map((item, index) => (
            <LotteryCard
              data={item}
              key={index}
              canDiscard={lotteryData.lottery_info?.can_discard}
              refundPoint={lotteryData.lottery_info?.refund_point}
              hasCancelFlag={hasCancelFlag}
            />
          ))}
        </div>
      </div>
      <div id="lottery-icon-wrapper">
        <div className="main-content">
          <div
            className="d-flex flex-wrap"
            style={{ marginTop: 80, paddingTop: 20, width: 'max-content', maxWidth: 920 }}
            id="share-sns-wrapper"
          >
            {lotteryData?.list_prize?.map((item, index) => (
              <LotteryIcon data={item} key={index} />
            ))}
          </div>
          <div className="my-color-black-400 NotoSansJP">※数字は当せん個数。（）内は破棄数。</div>

          <div
            style={{ margin: '0 auto', textAlign: 'center', marginTop: 80 }}
            className="d-flex justify-content-center"
          >
            <TButton
              title={`${lotteryData?.lottery_info?.can_buy ? 'もう一度購入する' : '販売終了'}`}
              className={`${lotteryData?.lottery_info?.can_buy ? 'tertiary' : 'primary'}`}
              id="goToBuy"
              onClick={() =>
                lotteryData?.lottery_info?.can_buy && history.push(`/purchase/${lotteryId}`)
              }
              disabled={!lotteryData?.lottery_info?.can_buy}
            />
          </div>

          <div className="share-sns">
            <div className="title">
              <img src={iconBeside} alt="icon" className="icon" />
              <div className="text-share NotoSansJP">結果をシェアする</div>
              <img src={iconBeside} alt="icon" className="icon" />
            </div>
            <div className="icon-wrapper">
              <img
                src={facebookIcon}
                alt="icon"
                className="icon icon-fb"
                onClick={() => handleShare('fb')}
              />
              <img
                src={twitterIcon}
                alt="icon"
                className="icon"
                onClick={() => handleShare('tw')}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="main-content" style={{ marginBottom: 100 }}>
        <div>
          <HistoryPurchase data={lotteryData?.orders} />
        </div>
      </div>

      <ModalDiscardGuide
        isShowDiscardGuide={isShowDiscardGuide}
        setShowDiscardGuide={setShowDiscardGuide}
      />
    </>
  );
};

export default MyCollectionLotteryDetailPC;
